export type { Action as DialogAction, DialogProps } from './Dialog';
export { Dialog } from './Dialog';
